import React from 'react';
import Paper from '@material-ui/core/Paper';
import PlayIcon from '@material-ui/icons/PlayArrow';
import StopIcon from '@material-ui/icons/Stop';
import LoadingIcon from '@material-ui/icons/FilterTiltShift';
import IconButton from '@material-ui/core/IconButton';
import SaveIcon from '@material-ui/icons/SaveAlt';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  paper: {
    paddingRight: 20,
    textDecoration: 'none',
    width: 'calc(25% - 10px)',
    color: theme.palette.text.primary,
    display: 'inline-flex',
    alignItems: 'center',
    fontSize: '0.85em',
    margin: '0 5px 10px',
    justifyContent: 'space-between',
    '& a': {
      color: '#ccc',
      transition: 'color 0.3s',
      marginTop: 5,
      '&:hover': {
        color: '#666',
      }
    },
  },
  title: {
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '100%',
  },
  play: {
    cursor: 'pointer',
  },
  loading: {
    animation: 'spin 2s linear infinite',
  },
  '@media (max-width: 850px)': {
    paper: {
      width: 'calc(33.3333% - 10px)',
    }
  },
  '@media (max-width: 600px)': {
    paper: {
      width: 'calc(50% - 10px)',
    }
  },
  '@media (max-width: 450px)': {
    paper: {
      width: 'calc(100% - 10px)',
    }
  }
}));

function MediaSingle(props) {
  const classes = useStyles();
  const { file, status, baseUrl } = props;
  const url = file.url;

  return (
    <Paper
      key={file.url}
      elevation={1}
      className={classes.paper}
    >
      {(status === 'paused' || status === 'ended') && <IconButton onClick={() => props.play(file)}>
        <PlayIcon className={classes.play} />
      </IconButton>}
      {status === 'playing' && <IconButton onClick={() => props.stop()} color="secondary">
        <StopIcon className={classes.play} />
      </IconButton>}
      {status === 'loading' && <IconButton color="secondary">
        <LoadingIcon className={classes.loading} />
      </IconButton>}
      <span className={classes.title}>{file.title}</span>
      <a download href={url}><SaveIcon /></a>
    </Paper>
  )
}

export default MediaSingle;